var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      










































































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel\" overlay=\"$ctrl.loading.main\"\u003E\u003Cdiv class=\"cockipit-panel__title\"\u003ESpecial Admin Panel\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body employee-filters-containter\"\u003E\u003Crow\u003E\u003C!--VN-4216--\u003E\u003Chr\u003E\u003Ch5\u003EUpdate existing open orders and direct bonus projects on live\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.processExistingOrders()\"\u003EProcess orders\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.validate_mpp_basket_dates_for_pickup_issues()\"\u003Evalidate_mpp_basket_dates_for_pickup_issues\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.get_wrong_future_data_report()\"\u003Eget_wrong_future_data_report\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.recalculate_bonus_future_data()\"\u003Erecalculate_bonus_future_data\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.get_future_checkouts_with_missing_state()\"\u003Eget_future_checkouts_with_missing_state\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.get_mpp_baskets_with_diff_in_order_closed_date_and_begin()\"\u003Eget_mpp_baskets_with_diff_in_order_closed_date_and_begin\u003C\u002Fbutton\u003E\u003Chr\u003E\u003C\u002Frow\u003E\u003Crow\u003E\u003Chr\u003E\u003Ch5\u003Etesting pc_mobile_combination pre-ending\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.testPcCombinedPreending()\"\u003EPC_MOBILE COMBINED PRE-ENDING TEST\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003EAdmin portal settings\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.jumpToAdminPortal()\"\u003EJump to Admin portal administration page\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Chr\u003E\u003Ch5\u003ECreate internal NLTG contacts by acticve status and toc\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary control_process_btn isOutline\" ng-click=\"$ctrl.createInitialNewsletterContactsByToc()\"\u003ECreate internal NLTG contacts\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003ESync customer's internal contacts by NLTG\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary control_process_btn isOutline\" ng-click=\"$ctrl.createInitialCustomersUsersByNLTG()\"\u003ECreatea initial customer nltg contacts\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003ESet configurations on baskets\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary control_process_btn isOutline\" ng-click=\"$ctrl.setConfigurationsOnBaskets()\"\u003ESet configurations on baskets\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003EMigrate current bonus approvals\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary control_process_btn isOutline\" ng-click=\"$ctrl.updateDeclinedBonusBaskets()\"\u003EUpdate Declined Bonus Baskets\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003EFix Configurations On Baskets\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary control_process_btn isOutline\" ng-click=\"$ctrl.fixConfigurationsOnBasket()\"\u003EFix Configurations On Baskets\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003EAdd order_closed_date to basket exports\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary control_process_btn isOutline\" ng-click=\"$ctrl.addOrderClosedDateToExportedBaskets()\"\u003EAdd order_closed_date\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003EManual Expiration of Baskets\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.expireBaskets()\"\u003EEXPIRE BASKETS\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Chr\u003E\u003Ch5\u003EInform for leasing end in three months\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.initBuyingProcessTicketNumber()\"\u003EInit Leasing END IN FOUR MONTHS\u003C\u002Fbutton\u003E\u003Ch5\u003EInform for leasing end in three months\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.informForLeasingEndInThreeMonths()\"\u003EINFORM FOR LEASING END IN THREE MONTHS\u003C\u002Fbutton\u003E\u003Ch5\u003EStart MPP Buying Process\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.startBasketDecisionProcess()\" data-cy=\"vn.administration.special.adminPanel.buttonStartMppBuyingProcess\"\u003ESTART DECISION PROCESS\u003C\u002Fbutton\u003E\u003Ch5\u003EReminder for MPP Buying process\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.reminderForBuyingProcesses()\"\u003EREMIND DECISION PROCESS\u003C\u002Fbutton\u003E\u003Ch5\u003EBilling Process Reminders\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.billingProcessReminders()\"\u003EBilling Process Reminders\u003C\u002Fbutton\u003E\u003Ch5\u003EExpire User Decision Processes\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.expireUserDecisionProcesses()\"\u003EExpire User Decision Processes\u003C\u002Fbutton\u003E\u003Ch5\u003EGet Buying Process Emails Report\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.getBuyingProcessEmailsReport()\"\u003EGet Buying Process Emails Report\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Chr\u003E\u003Chr\u003E\u003Chr\u003E\u003Ch5\u003EGenerate Invoices\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.generateInvoices()\"\u003EGENERATE INVOICES\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003EConvert Existing Preend Information Dates to Correct Datetimes in employee_leasing_pcleasing\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.convertPreendInformationDates()\"\u003EConvert Existing Preend Information Dates\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003ESend Yearly Initiation Emails\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.sendYearlyInitiationEmails()\"\u003ESend Yearly Initiation Emails\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003Egenerate_overview_document_for_yearly_for_testing\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.generate_overview_document_for_yearly_for_testing()\"\u003Egenerate_overview_document_for_yearly_for_testing\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003Esend_yearly_emails_to_bo_for_already_finished_processes\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.send_yearly_emails_to_bo_for_already_finished_processes()\"\u003Esend_yearly_emails_to_bo_for_already_finished_processes\u003C\u002Fbutton\u003E\u003Chr\u003E\u003C!--VN-3406--\u003E\u003Ch5\u003EInform for leasing end in two months | KONSTANTIN\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.informForLeasingEndInTwoMonths()\"\u003EInform for leasing end in two months | KONSTANTIN\u003C\u002Fbutton\u003E\u003Chr\u003E\u003C!--VN-3416--\u003E\u003Ch5\u003EVN-3416 1 | manual_emails_for_mpp_buying_process_get_ticket_ids | KONSTANTIN\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.manual_emails_for_mpp_buying_process_get_ticket_ids()\"\u003EVN-3416 1 | KONSTANTIN\u003C\u002Fbutton\u003E\u003Chr\u003E\u003C!--VN-3416--\u003E\u003Ch5\u003EVN-3416 2 | parse_buying_process_email_manually | KONSTANTIN\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.parse_buying_process_email_manually()\"\u003EVN-3416 2 | KONSTANTIN\u003C\u002Fbutton\u003E\u003Chr\u003E\u003C!--VN-3416--\u003E\u003Ch5\u003EVN-3416 3 | manual_emails_for_mpp_buying_process | KONSTANTIN\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.manual_emails_for_mpp_buying_process()\"\u003EVN-3416 3 | KONSTANTIN\u003C\u002Fbutton\u003E\u003Chr\u003E\u003C!--VN-3418--\u003E\u003Ch5\u003EVN-3418 | parse_invoice_manually | KONSTANTIN\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.parse_invoice_manually()\"\u003EVN-3418 | KONSTANTIN\u003C\u002Fbutton\u003E\u003Chr\u003E\u003C!--VN-3418--\u003E\u003Ch5\u003EVN-3439 | resend_missing_cyberport_emails_VN3439 | KONSTANTIN\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.resend_missing_cyberport_emails_VN3439()\"\u003EVN-3439 | KONSTANTIN\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003Efix_future_data\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.fix_future_data()\"\u003Efix_future_data\u003C\u002Fbutton\u003E\u003Chr\u003E\u003C!--VN-3665--\u003E\u003Ch5\u003EReexport mpp baskets\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.reexportMppBaskets()\"\u003Ereexport mpp baskets\u003C\u002Fbutton\u003E\u003C\u002Fh5\u003E\u003Chr\u003E\u003Ch5\u003EFix Future Checkout Baskets\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.fixFutureCheckoutBaskets()\"\u003EfixFutureCheckoutBaskets\u003C\u002Fbutton\u003E\u003C\u002Fh5\u003E\u003Chr\u003E\u003Ch5\u003Etest_sftp_fid\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.test_sftp()\"\u003Etest_sftp_fid\u003C\u002Fbutton\u003E\u003Ch5\u003Evalidate_pdfa\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.validate_pdfa()\"\u003Evalidate_pdfa\u003C\u002Fbutton\u003E\u003Ch5\u003EVN-4481 FIX WRONG BASKET STATES\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.fixProblematicMPPBasketsVN4481()\"\u003EVN-4481\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003EP92VN-1650 Send missing mpp leasing emails\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.sendLeasingEmailsManually()\"\u003EVN-4789\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003EVN-4789 Recreate billing process for order id - 5004199805\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.recreateBillingProcess()\"\u003EVN-4789\u003C\u002Fbutton\u003E\u003Chr\u003E\u003Ch5\u003EP92VN-600 expireBikeleasingBonuses\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.expireBikeleasingBonuses()\"\u003EexpireBikeleasingBonuses\u003C\u002Fbutton\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.IS_DEV_ENVIRONMENT || $ctrl.IS_STAGE_ENVIRONMENT\"\u003E\u003Chr\u003E\u003Ch5\u003EProcess BC Wrapper Service Direct Bonus Invoice Orders\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.testBCWrapperCronJob()\"\u003ERun\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Chr\u003E\u003Ch5\u003EActivate Future Checkouts Manually\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.activateFutureCheckoutsExternal()\"\u003EactivateFutureCheckoutsExternal\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Chr\u003E\u003Ch5\u003EExport Bonus Projects\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.exportBonusProjects()\"\u003EExport Bonus Projects\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Chr\u003E\u003Ch5\u003EExpire NEO Contract Digital Signing Requests\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.expireNeoContractsAwaitingForSigning()\"\u003EExport Neo Contract With Digital Signing\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Chr\u003E\u003Ch5\u003EExpire Normal Digital Signing Requests\u003C\u002Fh5\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.expireDigitalSigningRequests()\"\u003EExport Normal Digital Signing Request\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Frow\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;